import { Component, Mixins } from 'vue-property-decorator';
import PrivilegeMixin from './PrivilegeMixin';
import SimpleButton from '@/components/SimpleButton.vue';
import RoundButton from '@/components/RoundButton.vue';
import RoundButtonMenu from '@/components/RoundButtonMenu.vue';
import DetailField from '@/components/DetailField.vue';
import draggable from 'vuedraggable';
import formatting from '@/formatting';
import { api } from '../api';

@Component({
  components: {
    SimpleButton,
    RoundButton,
    RoundButtonMenu,
    DetailField,
    draggable
  }
})
export default class RelationMixin extends Mixins(PrivilegeMixin) {
  public api = api;
  public formatting = formatting;

  public overviewTitles = {
    customers: 'Klanten',
    suppliers: 'Leveranciers'
  };

  public detailTitles = {
    customers: 'Klant',
    suppliers: 'Leverancier'
  };

  public deleteTitles = {
    customers: 'deze klant',
    suppliers: 'deze leverancier'
  };

  public urls = {
    customers: '/sale/customers',
    suppliers: '/purchase/suppliers'
  };

  public fixedFilters = {
    customers: { is_customer: true },
    suppliers: { is_supplier: true }
  };

  public filterNames = {
    customers: 'customers',
    suppliers: 'suppliers'
  };

  public isCustomer() {
    return this.getView(this.$route.path) === 'customers';
  }

  public isSupplier() {
    return this.getView(this.$route.path) === 'suppliers';
  }

  public getView(path) {
    if (path.includes('customers')) {
      return 'customers';
    } else if (path.includes('suppliers')) {
      return 'suppliers';
    } else {
      return '';
    }
  }
}
